import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useCompetition } from '../contexts/CompetitionContext';
import {
  fetchCompetitionLeaderboard,
  fetchMyBetsInCompetition
} from '../services/competitionApi';

/**
 * Points + rank for current user in active competition (TopNav, summary cards).
 */
export function useCompetitionSummary() {
  const { user } = useAuth();
  const { competitionSlug } = useCompetition();
  const [state, setState] = useState({
    points: 0,
    rank: null,
    loading: true
  });

  useEffect(() => {
    if (!user?._id) {
      setState({ points: 0, rank: null, loading: false });
      return;
    }

    let cancelled = false;
    setState((s) => ({ ...s, loading: true }));

    (async () => {
      try {
        const [leaderboardRows, myBets] = await Promise.all([
          fetchCompetitionLeaderboard(competitionSlug),
          fetchMyBetsInCompetition(competitionSlug)
        ]);
        if (cancelled) return;

        const myRow = leaderboardRows.find(
          (r) => String(r.userId) === String(user._id)
        );
        const points =
          myRow?.totalPoints ??
          myBets
            .filter((b) => b.isCalculated)
            .reduce((sum, b) => sum + (b.points || 0), 0);
        const rank =
          leaderboardRows.findIndex((r) => String(r.userId) === String(user._id)) + 1;

        setState({
          points,
          rank: rank > 0 ? rank : null,
          loading: false
        });
      } catch {
        if (!cancelled) setState({ points: 0, rank: null, loading: false });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [user?._id, competitionSlug]);

  return state;
}
